export default __webpack_public_path__ + "static/media/clip_3.61715693.jpeg";